module.exports = __webpack_public_path__ + "img/M300L_qmp.c029c190.png";